import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaGlobe, FaLinkedinIn } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { useTranslation } from "../i18n";

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const copyright = t("footer.copyright").replace("{{year}}", year);

  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>{t("footer.designed")}</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>{copyright}</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/LokeshKhandelwal"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://leetcode.com/u/lokesh1911e/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LeetCode"
              >
                <SiLeetcode />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/lokesh1911e/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.lokeshkhandelwal.com/"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Portfolio website"
              >
                <FaGlobe />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
